import { ConversationStep, Theme } from "../../interfaces";
import { getApplicantSteps } from "../ApplicantSteps";
import AppointmentSteps from "../AppointmentSteps";
import EscalationSteps from "../EscalationSteps";
import WealthSteps from "./WealthSteps";

const wealth = (theme: Theme) => {
  return [
    ...WealthSteps(theme),
    ...getApplicantSteps(1),
    ...AppointmentSteps(theme),
    {
      id: "flow_end",
      message:
        "Great, you're all booked in. I'll send you a confirmation email shortly.",
      playAnimation: true,
      type: "bot",
      trigger: "end_greeting",
    },
    {
      id: "end_greeting",
      message: "Have a great day.",
      end: true,
      type: "bot",
    },
    ...EscalationSteps,
  ] as ConversationStep[];
};

export default wealth;
